import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-add-button-atom',
  templateUrl: './add-button-atom.component.html',
})
export class AddButtonAtomComponent {
  @Output() buttonClick = new EventEmitter<Event>();
}
